import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CameraIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_102_120)">
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.10001 8H14.3L11 2.3"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.10001 17.7L9.70001 8"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 21.7L7.39999 12"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.9 16H9.70001"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9 6.3L14.3 16"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 2.3L16.6 12"
          stroke={color}
          strokeWidth={strokeWidth || 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_102_120">
          <rect width="24" height="24" fill={color} />
        </clipPath>
      </defs>
    </BaseIcon>
  ),
);

CameraIcon.displayName = 'CameraIcon';
